import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';
import {numberRange} from 'src/common-utils/nuberRange';
import {useTranslations} from 'src/providers/translation';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
  items?: any;
}

export const items = numberRange(1, 3).map(num => ({
  label: num.toString(),
  value: num,
}));

export const Import = (
  key: string = 'maintenanceSessions',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Number of Sessions',
  key,
  validators: [
    // {validate: 'require_with_values', fieldValues: {method: 'trial_by_trial'}},
  ],
});

export const Value = (value: string) => {
  return value;
};

export const Display = ({value}: DisplayProps) => {
  const translations = useTranslations();
  return (
    <DataItem>
      <Text style={[Typography.H6]}>{translations('number_of_sessions')}</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  const translations = useTranslations();
  return (
    <HookFormSelectInput
      name={(name ? name + '.' : '') + 'maintenanceSessions'}
      label={translations('number_of_sessions')}
      placeholder={translations('number_of_sessions')}
      helper={''}
      required={false}
      items={items}
    />
  );
};

export const validation = () =>
  Yup.string().required('Number of Sessions is required');

export default Input;
